import { render, staticRenderFns } from "./RecycleTypeChartBar.vue?vue&type=template&id=150ffec8&scoped=true"
import script from "./RecycleTypeChartBar.vue?vue&type=script&lang=js"
export * from "./RecycleTypeChartBar.vue?vue&type=script&lang=js"
import style0 from "./RecycleTypeChartBar.vue?vue&type=style&index=0&id=150ffec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ffec8",
  null
  
)

export default component.exports